'use client';

import { forwardRef } from 'react';
import type { ReactNode } from 'react';
import type { PaperProps as MantinePaperProps } from '@mantine/core';
import { Paper as MantinePaper } from '@mantine/core';

// Paper is an atomic surface primitive (like Box): styling escape hatches stay
// open so call sites can apply CSS-module classes / dynamic styles.
// v7 component prop types no longer include `children`.
export type PaperProps = MantinePaperProps & { children?: ReactNode };

export const Paper = forwardRef<HTMLDivElement, PaperProps>((props, ref) => {
  return <MantinePaper ref={ref} {...props} />;
});
Paper.displayName = 'Paper';
